@if (shouldShowGrid()) {
  <div class="mt-2 flex-1 min-h-0 overflow-hidden">
    <app-ng-table-results
      tableName="{{ tableName }}"
      [tableData]="resultsGrid"
      [columnDefinitions]="cols"
      [autoHeight]="true"
    />
  </div>
}

@if (selectedResultsDisplay === 'plot') {
  <div class="plot mt-2 flex-1 min-h-0 flex overflow-hidden">
    @if (shouldShowPlot()) {
      <app-xy-line-plot
        [plotData]="plotData"
        [xAxisTitle]="xAxisTitle"
        [yAxisTitle]="yAxisTitle"
        [plotName]="plotName"
        [downloadPlotName]="downloadPlotName"
        [reverseAutoRange]="true"
        [plotTitle]="tableName"
        [legendGroupClick]="'toggle'"
        [plotOrientation]="''"
        [xyLinePlotStore]="operationEnvelopeStore"
      ></app-xy-line-plot>
    }
  </div>
}
